import React from 'react';
import { CellScope, Table, TableBody, TableCell, TableHead, TableRow } from '../../../components/organisms/Table';
import { isEmptyArray } from '../../../lib/typeGuards';
import { usePageStatistics } from './usePageStatistics';
import { StatisticDaily, StatisticMonthly } from '../PageStatistics.types';
import { DateFormat } from '../../../_lib/components/DateFormat';

export type PageStatisticsTable = {
  statistics: StatisticDaily[] | StatisticMonthly[];
  type: 'daily' | 'monthly';
};

/**
 * Table to display statistics that contain individual data.
 */
export function PageStatisticsTable({ statistics, type }: PageStatisticsTable) {
  const {
    dateTrans,
    total,
    individual,
    totalSubtree,
    individualSubtree,
    cellModifier,
    cellModifierLarge,
    getCaption,
    getDateFormatByType,
  } = usePageStatistics(type);

  if (isEmptyArray(statistics)) {
    return null;
  }

  return (
    <div className="page-statistics">
      <Table caption={getCaption()} captionHidden={false}>
        <TableHead>
          <TableRow>
            <TableCell modifier={cellModifierLarge}>{dateTrans}</TableCell>
            <TableCell modifier={cellModifier}>{total}</TableCell>
            <TableCell modifier={cellModifier}>{individual}</TableCell>
            <TableCell modifier={cellModifierLarge}>{totalSubtree}</TableCell>
            <TableCell modifier={cellModifierLarge}>{individualSubtree}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {statistics?.map(item => (
            <TableRow key={item.date + type}>
              <TableCell isTableHead modifier="lowpadding-vertical-center" scope={CellScope.ROW}>
                <DateFormat date={item.date} format={getDateFormatByType()} />
              </TableCell>
              <TableCell modifier={cellModifier} dataHead={total}>
                {item.total}
              </TableCell>
              <TableCell modifier={cellModifier} dataHead={individual}>
                {item.individual}
              </TableCell>
              <TableCell modifier={cellModifier} dataHead={totalSubtree}>
                {item.totalSubTree}
              </TableCell>
              <TableCell modifier={cellModifier} dataHead={individualSubtree}>
                {item.individualSubTree}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
